'use client'

import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import styles from './index.module.css'
import { fetcher, throttle } from '@/utils'

import List, { type ListRecordRaw } from './list';
import Loading from '@/components/loading/wave'

export { ListRecordRaw };
export { List };

interface Props extends PropsWithChildren {
  /**
   * 数据总量 传入0则不会再发起请求
   */
  total?: number;
  className?: string;
  /**
   * 列表标题
   */
  title?: string | React.ReactNode;
  throshold?: number;
  /**
   * 请求的api接口
   */
  requestUrl: string;
}

export default function Index({ children, className = '', title = '最近更新', total = 0, throshold = 0.7, requestUrl: url }: Props) {
  const pageInfo = useRef({
    current: 2,
    pageSize: 10,
    total,
  }).current;
  const status = useRef({
    loading: false,
    finish: false,
  }).current;
  const [loading, setLoading] = useState<'normal' | 'loading' | 'finish'>('normal');
  const [list, setListData] = useState<ListRecordRaw[]>([])

  function getData() {
    setLoading('loading');
    fetcher<{
      data: ListRecordRaw[];
      total: number;
      code: number;
    }>({
      url,
      method: 'post',
      body: JSON.stringify({
        current: pageInfo.current,
        pageSize: pageInfo.pageSize,
      })
    }).then(res => {
      if (res.code === 200) {
        setLoading('normal')
        pageInfo.current++;
        if (pageInfo.current * pageInfo.pageSize >= total) {
          status.finish = true;
          setLoading('finish');
        }
        setListData(arr => [...arr, ...res.data])
      }
    }).finally(() => {
      status.loading = false;
    })
  }

  useEffect(() => {
    const handleScroll = (e: Event) => {
      if (e.target === document && document.scrollingElement) {
        const { scrollHeight, scrollTop } = document.scrollingElement;
        const vh = window.innerHeight;
        // 如果滚动距离超过了阈值且不在加载状态
        if (scrollTop / (scrollHeight - vh) > throshold && !status.finish && !status.loading) {
          status.loading = true;
          getData();
        }
      }
    }
    if (total && url) {
      const controller = new AbortController();
      const signal = controller.signal;

      // 监听滚动事件来触发更新
      window.addEventListener('scroll', throttle(handleScroll), { signal });

      return () => {
        setLoading('normal');
        status.finish = false;
        status.loading = false;
        controller.abort();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, url])
  return (
    <>
      <div className={`${styles.wrapper} ${className}`}>
        <h2 className={styles.title}>{title}</h2>
        {children}
        {/* 造孽哦 我怎么搞了一个这么耦合的组件 */}
        <List dataSource={list} />
      </div>
      <div className={styles.more}>
        {
          loading === 'loading' ? <Loading /> : loading === 'finish' ? <p>人家也是有底线的~~</p> : null
        }
      </div>
    </>

  )
}
